"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIRAL_SOURCE_USER_ID = exports.VIRAL_SOURCE_PORTAL_ID = exports.LANDING_PAGES_SIDEBAR = exports.LANDING_PAGE_TYPE = exports.PARTNER_ID = exports.SKIP_SETUP = exports.MARKETING_FREE_EMAIL_SIDEBAR = exports.CRM_EMAIL_SIDEBAR = exports.DOCUMENTS_SIDEBAR = exports.FORMS_SIDEBAR = exports.LEADFLOWS_SIDEBAR = exports.LIVECHAT_SIDEBAR = exports.SALES_EXTENSION_SIDEBAR = exports.MEETING_SIDEBAR = void 0;
var MEETING_SIDEBAR = 'MEETING_SIDEBAR';
exports.MEETING_SIDEBAR = MEETING_SIDEBAR;
var SALES_EXTENSION_SIDEBAR = 'SALES_EXTENSION_SIDEBAR';
exports.SALES_EXTENSION_SIDEBAR = SALES_EXTENSION_SIDEBAR;
var LIVECHAT_SIDEBAR = 'LIVECHAT_SIDEBAR';
exports.LIVECHAT_SIDEBAR = LIVECHAT_SIDEBAR;
var LEADFLOWS_SIDEBAR = 'LEADFLOWS_SIDEBAR';
exports.LEADFLOWS_SIDEBAR = LEADFLOWS_SIDEBAR;
var FORMS_SIDEBAR = 'FORMS_SIDEBAR';
exports.FORMS_SIDEBAR = FORMS_SIDEBAR;
var DOCUMENTS_SIDEBAR = 'DOCUMENTS_SIDEBAR';
exports.DOCUMENTS_SIDEBAR = DOCUMENTS_SIDEBAR;
var CRM_EMAIL_SIDEBAR = 'CRM_EMAIL_SIDEBAR';
exports.CRM_EMAIL_SIDEBAR = CRM_EMAIL_SIDEBAR;
var MARKETING_FREE_EMAIL_SIDEBAR = 'MARKETING_FREE_EMAIL_SIDEBAR';
exports.MARKETING_FREE_EMAIL_SIDEBAR = MARKETING_FREE_EMAIL_SIDEBAR;
var SKIP_SETUP = 'SKIP_SETUP';
exports.SKIP_SETUP = SKIP_SETUP;
var PARTNER_ID = 'PARTNER_ID';
exports.PARTNER_ID = PARTNER_ID;
var LANDING_PAGE_TYPE = 'LANDING_PAGE_TYPE';
exports.LANDING_PAGE_TYPE = LANDING_PAGE_TYPE;
var LANDING_PAGES_SIDEBAR = 'LANDING_PAGES_SIDEBAR';
exports.LANDING_PAGES_SIDEBAR = LANDING_PAGES_SIDEBAR;
var VIRAL_SOURCE_PORTAL_ID = 'VIRAL_SOURCE_PORTAL_ID';
exports.VIRAL_SOURCE_PORTAL_ID = VIRAL_SOURCE_PORTAL_ID;
var VIRAL_SOURCE_USER_ID = 'VIRAL_SOURCE_USER_ID';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

exports.VIRAL_SOURCE_USER_ID = VIRAL_SOURCE_USER_ID;

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}